module.exports = __webpack_public_path__ + "media/images/circle-of-care-teams-af2866f6.svg";